import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyLensTypeVM } from 'src/app/models/view-models/company-lens-type-vm.model';
import { CompanyLensesHelperService } from 'src/app/services/local/company-lenses-helper.service';
import { OrderManagerService } from 'src/app/services/local/order-manager.service';

@Component({
    selector: 'app-lens-selection',
    templateUrl: './lens-selection.component.html',
    styleUrls: ['./lens-selection.component.scss'],
    standalone: false
})
export class LensSelectionComponent implements OnInit {
  toggleClass: boolean = true;
  companyLensesByType: CompanyLensTypeVM | undefined;
  hasReaders: boolean = false;
  hasPlano: boolean = false;
  hasPrescription: boolean = false;
  isEditMode: boolean = false;
  queryParams: {} = {};

  constructor(private _router: Router,
              private _route: ActivatedRoute,
              public _orderManagerService: OrderManagerService,
              private _companyLensesHelperService: CompanyLensesHelperService) { }

  ngOnInit(): void {
    this._route.queryParams
    .subscribe(params => {
      this.isEditMode = params.isEditMode === 'true';
      this.queryParams = this.isEditMode ? {'isEditMode' : this.isEditMode} : {};
      this.getAllLenses();
    });
  }

  getAllLenses() {
    this._companyLensesHelperService.getAllLenses()
    .subscribe((data: any) => {
      if (data) {
        this.companyLensesByType = data;
        this.checkTypes();
      } else {
        this._router.navigate(['/dashboard']);
      }
    }, (error: any) => {
      
    });
  }

  checkTypes() {
    if (this.companyLensesByType) {
      this.checkForAutoNavigate();
      if (this.companyLensesByType.prescriptionLenses.length > 0) {
        this.hasPrescription = true;
      }      
      if (this.companyLensesByType.readerLenses.length > 0) {      
        this.hasReaders = true;
      }
      if (this.companyLensesByType.planoLenses) {
        this.hasPlano = true;
      }
    }    
  }

  checkForAutoNavigate() {
    if (!this.companyLensesByType?.planoLenses && this.companyLensesByType?.readerLenses?.length == 0) {
      this._router.navigate(['/lens-selection/prescription'], { queryParams: this.queryParams });
    }
    else if (this.companyLensesByType?.prescriptionLenses?.length == 0 && this.companyLensesByType?.readerLenses?.length == 0) {
      this._router.navigate(['/lens-selection/non-prescription'], { queryParams: this.queryParams });
    }
    else if (this.companyLensesByType?.prescriptionLenses?.length == 0 && this.companyLensesByType?.readerLenses?.length == 0) {
      this._router.navigate(['/lens-selection/readers'], { queryParams: this.queryParams });
    }
  }
}
